import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { copySchoolFile } from '../../../../../../../stores/school-files/school-files.actions'
import { getSchoolFile } from '../../../../../../../stores/school-files/school-files.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id, history }) => {
  const file = getSchoolFile(state, id)
  return {
    id: file.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onCopy: () => {
    return dispatch(copySchoolFile(ownProps.id)).then(() =>
      ownProps.history.push('/my-files')
    )
  }
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, mergeProps)(ContextMenu)
)
